import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import {
  faHouse,
  faUser,
  faUsers,
  faRightFromBracket,
  faArrowLeft,
  faUserShield,
  faArrowRight,
  faFileLines,
  faTools,
  faClipboardList,
  faInfoCircle,
  faUserPlus,
  faRepeat,
  faAddressBook,
  faComments,
  faBars,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import BASE_URL from '../config';
import "./Sidebar.css";

const Sidebar = ({ onToggle = () => { } }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [email, setEmail] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const fetchEmail = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const response = await fetch(`${BASE_URL}api/user/profile`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setEmail(data.email);
        } else {
          console.error("Failed to fetch user profile.");
        }
      } catch (error) {
        console.error("Error fetching email:", error);
      }
    };

    fetchEmail();
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
    onToggle(!isCollapsed);
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const handleNavigation = (e, path) => {
    if (location.pathname === path) {
      e.preventDefault();
    }
    // Close mobile menu on navigation
    setIsMobileOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <button className="mobile-menu-btn" onClick={toggleMobileSidebar}>
        <FontAwesomeIcon icon={isMobileOpen ? faTimes : faBars} />
      </button>

      {/* Mobile Overlay */}
      {isMobileOpen && <div className="mobile-overlay" onClick={toggleMobileSidebar}></div>}

      <div className={`sidebar ${isCollapsed ? "collapsed" : ""} ${isMobileOpen ? "mobile-open" : ""}`}>
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={() => setIsMobileOpen(false)}>
            <img
              src="https://res.cloudinary.com/softisans-com/image/upload/v1592236220/Logo/Softisans-Logo.png"
              alt="Softisans Logo"
            />
          </Link>
        </div>

        {/* Toggle Button - Desktop Only */}
        <div className="toggle-btn desktop-only" onClick={toggleSidebar}>
          <FontAwesomeIcon
            icon={isCollapsed ? faArrowRight : faArrowLeft}
            style={{ color: "#39c09a" }}
          />
        </div>

        {/* Sidebar Menu */}
        <ul>
          {/* PARENT 1 - Dashboard */}
          <li>
            <Link to="/dashboard" onClick={(e) => handleNavigation(e, "/dashboard")}>
              <FontAwesomeIcon icon={faHouse} style={{ color: "white" }} />
              <span className="menu-text">Dashboard</span>
            </Link>
          </li>

          {/* PARENT 2 - Tasks (My Tasks + Bulk Tasks combined) */}


          {/* PARENT 3 - Administration */}
          <li className="dropdown">
            <a href="#" data-bs-toggle="collapse" data-bs-target="#adminMenu">
              <FontAwesomeIcon icon={faUserShield} style={{ color: "white" }} />
              <span className="menu-text">Administration</span>
              <FontAwesomeIcon 
                icon={faChevronDown} 
                className="collapse-icon" 
                style={{ color: "white", fontSize: "0.8em" }} 
              />
            </a>
          </li>
          <ul id="adminMenu" className="collapse submenu">
                      <li>
            <Link to="/teams" onClick={(e) => handleNavigation(e, "/teams")}>
              <span className="menu-text">Teams & Projects</span>
            </Link>
          </li>
                        <li>
              <Link to="/information" onClick={(e) => handleNavigation(e, "/information")}>
                <span className="menu-text">Info</span>
              </Link>
            </li>
            <li>
              <Link to="/clients-information" onClick={(e) => handleNavigation(e, "/clients-information")}>
                <span className="menu-text">Clients Information</span>
              </Link>
            </li>
			
			
            <li>
              <Link to="/pages" onClick={(e) => handleNavigation(e, "/pages")}>
                <span className="menu-text">Pages</span>
              </Link>
            </li>
            <li>
              <Link to="/users" onClick={(e) => handleNavigation(e, "/users")}>
                <span className="menu-text">Users</span>
              </Link>
            </li>
            <li>
              <Link to="/clients" onClick={(e) => handleNavigation(e, "/clients")}>
                <span className="menu-text">Clients</span>
              </Link>
            </li>
            <li>
              <Link to="/admin-reoccurring" onClick={(e) => handleNavigation(e, "/admin-reoccurring")}>
                <span className="menu-text">Reoccurring Tasks</span>
              </Link>
            </li>
            <li>
              <Link to="/create-team" onClick={(e) => handleNavigation(e, "/create-team")}>
                <span className="menu-text">Create Team</span>
              </Link>
            </li>
          </ul>

          {/* PARENT 4 - Teams & Projects */}


          <li className="dropdown">
            <a href="#" data-bs-toggle="collapse" data-bs-target="#tasksMenu">
              <FontAwesomeIcon icon={faClipboardList} style={{ color: "white" }} />
              <span className="menu-text">Tasks</span>
              <FontAwesomeIcon 
                icon={faChevronDown} 
                className="collapse-icon" 
                style={{ color: "white", fontSize: "0.8em" }} 
              />
            </a>
          </li>
          <ul id="tasksMenu" className="collapse submenu">
            <li>
              <Link to="/my-tasks" onClick={(e) => handleNavigation(e, "/my-tasks")}>
                <span className="menu-text">My Tasks</span>
              </Link>
            </li>
            <li>
              <Link to="/bulk-task-adder" onClick={(e) => handleNavigation(e, "/bulk-task-adder")}>
                <span className="menu-text">Bulk Tasks</span>
              </Link>
            </li>
                <li>
                  <Link to="/ongage-export" onClick={(e) => handleNavigation(e, "/ongage-export")}>
                    <span className="menu-text">Ongage</span>
                  </Link>
                </li>
				
			       	<li>
                  <Link to="/api-stats" onClick={(e) => handleNavigation(e, "/api-stats")}>
                    <span className="menu-text">API Stats</span>
                  </Link>
                </li>
                <li>
                  <Link to="/email-lead-extractor" onClick={(e) => handleNavigation(e, "/email-lead-extractor")}>
                    <span className="menu-text">Email Lead Extractor</span>
                  </Link>
                </li>

                				 <li>
                  <Link to="/database-shrinker" onClick={(e) => handleNavigation(e, "/database-shrinker")}>
                    <span className="menu-text">Database Shrinker</span>
                  </Link>
                </li>
                <li>
                  <Link to="/Base44-Sups" onClick={(e) => handleNavigation(e, "/Base44-Sups")}>
                    <span className="menu-text">Base44 Sups</span>
                  </Link>
                </li>


          </ul>
       
          {/* PARENT 6 - ESP */}
          <li className="dropdown">
            <a 
              href="#" 
              data-bs-toggle="collapse" 
              data-bs-target="#relayzoMenu"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faChartLine} style={{ color: "white" }} />
              <span className="menu-text">ESP</span>
              <FontAwesomeIcon 
                icon={faChevronDown} 
                className="collapse-icon" 
                style={{ color: "white", fontSize: "0.8em" }} 
              />
            </a>
          </li>
          <ul id="relayzoMenu" className="collapse submenu">
            <li>
              <Link to="/firstpremierlending" onClick={(e) => handleNavigation(e, "/firstpremierlending")}>
                <span className="menu-text">First Premier Lending</span>
              </Link>
            </li>
            <li>
              <Link to="/lizbuyshomes" onClick={(e) => handleNavigation(e, "/lizbuyshomes")}>
                <span className="menu-text">Liz Buys Homes</span>
              </Link>
            </li>
            <li>
              <Link to="/bestrate" onClick={(e) => handleNavigation(e, "/bestrate")}>
                <span className="menu-text">Best Rate</span>
              </Link>
            </li>
            <li>
              <Link to="/warmup" onClick={(e) => handleNavigation(e, "/warmup")}>
                <span className="menu-text">Warmup</span>
              </Link>
            </li>
            <li>
              <Link to="/warmupclean" onClick={(e) => handleNavigation(e, "/warmupclean")}>
                <span className="menu-text">Warmup Clean</span>
              </Link>
            </li>
            <li>
              <Link to="/mergecsv" onClick={(e) => handleNavigation(e, "/mergecsv")}>
                <span className="menu-text">Merge CSVs</span>
              </Link>
            </li>
            <li>
              <Link to="/domaincount" onClick={(e) => handleNavigation(e, "/domaincount")}>
                <span className="menu-text">Domain Count</span>
              </Link>
            </li>
            <li>
              <Link to="/template-setter" onClick={(e) => handleNavigation(e, "/template-setter")}>
                <span className="menu-text">Template Setter</span>
              </Link>
            </li>
            <li>
              <Link to="/analytics" onClick={(e) => handleNavigation(e, "/analytics")}>
                <span className="menu-text">Analytics</span>
              </Link>
            </li>
          </ul>

          {/* PARENT 7 - More (Utilities + Chat + Logout combined) */}
          <li className="dropdown">
            <a href="#" data-bs-toggle="collapse" data-bs-target="#moreMenu">
              <FontAwesomeIcon icon={faTools} style={{ color: "white" }} />
              <span className="menu-text">More</span>
              <FontAwesomeIcon 
                icon={faChevronDown} 
                className="collapse-icon" 
                style={{ color: "white", fontSize: "0.8em" }} 
              />
            </a>
          </li>
          <ul id="moreMenu" className="collapse submenu">


            {/* Show Utilities only for Rizwan */}
            {email === "rizwan@softisans.com" && (
              <>
                <li>
                  <Link to="/delete-email" onClick={(e) => handleNavigation(e, "/delete-email")}>
                    <span className="menu-text">Delete Email</span>
                  </Link>
                </li>
                <li>
                  <Link to="/search-email" onClick={(e) => handleNavigation(e, "/search-email")}>
                    <span className="menu-text">Search Email</span>
                  </Link>
                </li>
                <li>
                  <Link to="/domains" onClick={(e) => handleNavigation(e, "/domains")}>
                    <span className="menu-text">Domains</span>
                  </Link>
                </li>
                <li>
                  <Link to="/database-transaction" onClick={(e) => handleNavigation(e, "/database-transaction")}>
                    <span className="menu-text">Transactions</span>
                  </Link>
                </li>

                <li>
                  <Link to="/master-suppressions" onClick={(e) => handleNavigation(e, "/master-suppressions")}>
                    <span className="menu-text">Master Suppressions</span>
                  </Link>
                </li>
                <li>
                  <Link to="/keeper" onClick={(e) => handleNavigation(e, "/keeper")}>
                    <span className="menu-text">Keeper File</span>
                  </Link>
                </li>

              </>
            )}

          </ul>

          <li>
          <a
            href="https://chat.google.com/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => handleNavigation(e, "https://chat.google.com/")}
          >
            <FontAwesomeIcon icon={faComments} style={{ color: "white" }} />
            <span className="menu-text">Chat</span>
          </a>
        </li>

        <li>
          <Link to="#" onClick={handleLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} style={{ color: "white" }} />
            <span className="menu-text">Logout</span>
          </Link>
        </li>

        </ul>
      </div>
    </>
  );
};

export default Sidebar;